import Seo from "@/components/Seo";
import React from "react";
import PageMasthead from "@/components/PageMasthead";
import { Stagger, StaggerItem } from "@/components/motion";
import { Mail } from "lucide-react";
import useApi from "@/hooks/useApi";

const initials = (name) =>
  name.split(" ").filter(Boolean).slice(0, 2).map((n) => n[0]).join("").toUpperCase();

const LeaderCard = ({ p }) => (
  <div className="group bg-secondary rounded-2xl p-7 h-full flex flex-col" data-testid={`leader-${p.name}`}>
    <div className="flex items-center gap-4 mb-5">
      {p.image ? (
        <div className="ed-img w-16 h-16 rounded-full shrink-0">
          <img src={p.image} alt={p.name} />
        </div>
      ) : (
        <div className="w-16 h-16 rounded-full bg-primary text-white flex items-center justify-center shrink-0">
          <span className="headline text-xl">{initials(p.name)}</span>
        </div>
      )}
      <div className="min-w-0">
        <h3 className="headline text-xl text-ink leading-tight">{p.name}</h3>
        <p className="kicker mt-1 !text-foreground/50">{p.role}</p>
      </div>
    </div>
    <p className="text-[15px] leading-relaxed text-foreground/75 flex-1">{p.bio}</p>
    {(p.contact_for || p.email) && (
      <div className="mt-5 pt-4 border-t border-foreground/10 space-y-1.5">
        {p.contact_for && (
          <p className="text-[13px] text-foreground/70">
            <span className="font-bold uppercase tracking-wide text-foreground/50 text-[11px]">Contact for · </span>
            {p.contact_for}
          </p>
        )}
        {p.email && (
          <a href={`mailto:${p.email}`} className="inline-flex items-center gap-2 text-[13px] font-bold text-primary hover:underline break-all">
            <Mail size={13} /> {p.email}
          </a>
        )}
      </div>
    )}
  </div>
);

const Leadership = () => {
  const { data } = useApi("/leaders");
  const list = data || [];
  return (
    <div data-testid="leadership-page">
      <Seo
        title="Leadership"
        path="/leadership"
        description="The editors, analysts and operators behind Which Media — the group behind WhichSchoolAdvisor.com, SchoolsCompared.com, Top Schools Awards and EdinformaPlus."
      />
      <PageMasthead
        kicker="Leadership & Team"
        titleLines={[{ text: "The people behind" }, { text: "the authority", accent: true }]}
        standfirst="Editors, analysts and operators united by a belief that education deserves the highest standard of journalism and intelligence — across the UAE, the UK and beyond."
      />
      <section className="mx-auto max-w-[1400px] px-5 md:px-8 py-14 md:py-20">
        <Stagger className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((p) => (
            <StaggerItem key={p.id} className="h-full">
              <LeaderCard p={p} />
            </StaggerItem>
          ))}
        </Stagger>
      </section>
    </div>
  );
};

export default Leadership;
